<template>
  <div>
    <b-row>
      <b-col class="pt-4" cols="4">
        <b-card class="bCardGlobal">
          <p>Tratamientos cubiertos por el plan</p>
          <div class="d-flex g-5 align-items-center">
            <div class="barras d-flex w-100">
              <b-form-input
                  class="input-filter"
                  placeholder="Búsqueda por nombre"
                  type="text"
                  v-model="tratamientoBusqueda"
                  @keyup.enter="filtrarTratamientos"
              >
              </b-form-input>
              <b-button class="btn-extra-small" variant="info" @click="filtrarTratamientos">
                    <span
                    ><em class="buscar_svg" style="margin-top: 3px; height: 13px"></em
                    ></span>
              </b-button>
            </div>
            <b-button class="btn-extra-small" style="height: 25px; width: 70px; padding: 3px"
                      variant="outline-info" v-if="tratamientosSeleccionados.length > 0 || tratamientoBusqueda !== ''" @click="limpiar()">
              <span>Limpiar</span>
            </b-button>
          </div>
          <b-list-group class="overflow-auto mt-3" style="max-height: 469px" flush>
            <div
                v-if="!listaTratamientosFiltrada || listaTratamientosFiltrada.length === 0"
                class="text-center text-muted py-3"
            >
              ⚠ El tratamiento no se encuentra o no está cubierto por el plan
            </div>
            <div v-else class="pt-3 d-flex justify-content-between"
                 v-for="tratamiento of listaTratamientosFiltrada"
                 :key="tratamiento.idTratamiento"
            >
              {{ tratamiento.tratamiento }}
              <b-form-checkbox name="check-button" style="margin-left: 10px" v-model="tratamientosSeleccionados"
                               :value="{idTratamiento: tratamiento.idTratamiento, idTipoDescuentoPlan: tratamiento.idTipoDescuentoPlan}">
              </b-form-checkbox>
            </div>
          </b-list-group>
        </b-card>
      </b-col>
      <b-col class="pt-4" cols="8">
        <div class="mensaje_select_tratamiento" v-if="tratamientosSeleccionados.length === 0 && !loaderTratamientos">
          <span>SELECCIONA UN TRATAMIENTO PARA COMENZAR</span>
        </div>
        <div class="mt-3" style="height: 95%; display: flex; flex-direction: column; justify-content: space-between;"
             v-else-if="tratamientosSeleccionados.length > 0 && !loaderTratamientos">
          <b-table
              style="font-size: 11px"
              responsive
              id="listaTratamientos"
              :fields="headersTabla"
              :items="tratamientosList"
              empty-text="No se encontraron resultados"
              show-empty
              sticky-header
          >
            <template v-slot:head(precioClinica) class="text-center">
              <div class="text-center">
                Precio Clínica
              </div>
            </template>

            <template v-slot:head(precioDescuentoPlan)>
              <div class="text-center" v-if="!esPlanVale">
                Precio con <br> descuento plan
              </div>
              <div class="text-center" v-else>
                Precio con descuento vale
              </div>
            </template>

            <template v-slot:head(precioDescuentoEspecial) class="text-center">
              <div class="text-center">
                Precio con descuento <br> especial
              </div>
            </template>

            <template v-slot:cell(precioClinica)="row">
              <div class="d-flex justify-content-center">
                {{ Math.round(row.item.precioClinica) | moneda }}
              </div>
            </template>
            <template v-slot:cell(precioDescuentoPlan)="row">
              <div class="d-flex justify-content-center">
                  <span v-if="row.item.idTipoDescuentoPlan === 1">
                    ({{ row.item.descuento }}%) {{ Math.round(row.item.precioDescuentoPlan ) | moneda }}
                  </span>
                  <span v-if="row.item.idTipoDescuentoPlan === 2">
                    ({{ row.item.descuento | moneda }} descuento) {{ Math.round(row.item.precioDescuentoPlan) | moneda }}
                  </span>
                  <span v-if="row.item.idTipoDescuentoPlan === 3">
                    {{ row.item.descuento | moneda }} co-pago fijo
                  </span>
              </div>
            </template>
            <template v-slot:cell(precioDescuentoEspecial)="row">
              <div class="d-flex justify-content-center g-5">
                <span>
                  {{ Math.round(row.item.precioDescuentoEspecial) | moneda }}
                </span>
                <em
                    v-if="row.item.descuentoEspecial != null && row.item.descuentoEspecial > 0"
                    class="info_outline"
                    v-b-tooltip.topright.hover.v-light
                    :title="tooltipDescuento(row.item)"
                    style="width: 1.2em;">
                </em>
              </div>
            </template>
          </b-table>
          <div v-if="loaderTratamientos">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <span>
          <strong>Nota</strong>
                  <br> ESTOS PRECIOS SON DE REFERENCIA Y ESTÁN SUJETOS A TERMINOS Y CONDICIONES
        </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "CalculadoraPrecioTratamiento",
  components: {},
  props: {
    idPlan: Number,
    listaTratamientos: Array,
    listaTratamientosGrupo: Array,
    esPlanVale: Boolean,
  },
  watch: {
    tratamientosSeleccionados(newValue, oldValue) {
      // Evita llamadas innecesarias cuando no hay cambios reales
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.obtenerCalculosTratamientos();
      }
    },
    listaTratamientos: {
      handler() {
        this.unificarListados();
      },
      immediate: true
    },
    listaTratamientosGrupo: {
      handler() {
        this.unificarListados();
      },
      immediate: true
    }
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    tratamientoBusqueda: "",

    headersTabla: [
      {key: "tratamientoNombre", label: "Tratamiento", sortable: false,},
      {key: "precioClinica", label: "Precio Clínica", sortable: false},
      {key: "precioDescuentoPlan", label: "Precio con descuento plan", sortable: false},
      {key: "precioDescuentoEspecial", label: "Precio con descuento especial", sortable: false},
    ],

    tratamientosList: [],

    tratamientosSeleccionados: [],
    listaTratamientosOriginal: [],
    listaTratamientosFiltrada: [],

    loaderTratamientos: false,
  }),
  methods: {
    filtrarTratamientos() {
      if (!this.tratamientoBusqueda) {
        this.listaTratamientosFiltrada = [...this.listaTratamientosOriginal];
        return;
      }
      const texto = this.tratamientoBusqueda.toLowerCase();
      this.listaTratamientosFiltrada = this.listaTratamientosOriginal.filter(t =>
          t.tratamiento.toLowerCase().includes(texto)
      );
    },
    limpiar() {
      this.tratamientosSeleccionados = [];
      this.listaTratamientosFiltrada = [...this.listaTratamientosOriginal];
      this.tratamientoBusqueda = "";
      this.obtenerCalculosTratamientos();
    },

    obtenerCalculosTratamientos() {
      if (this.tratamientosSeleccionados.length === 0) {
        return;
      }
      this.loaderTratamientos = true;
      const parametros = {
        idPlan: this.idPlan,
        idClinica: this.$localStorageService.getIdClinica(),
        tratamientos: this.tratamientosSeleccionados
      };
      this.$http
          .post(this.$api + "empresas/obtener/tratamientos/calculadora", parametros)
          .then((response) => {
            this.tratamientosList = response.data.data;
            this.actualizarHeaders();
            this.loaderTratamientos = false;
          })
          .catch(function (error) {
            this.loaderTratamientos = false;
            console.error(error);
          });
    },

    actualizarHeaders() {
      // Verificamos si hay al menos uno con descuento especial
      const hayDescuentoEspecial = this.tratamientosList.some(
          item => item.descuentoEspecial != null && item.descuentoEspecial > 0
      );

      // Cantidad total de columnas
      const totalColumnas = hayDescuentoEspecial ? 4 : 3;

      // Calculamos el porcentaje dinámico
      const anchoColumna = (100 / totalColumnas) + '%';

      // Definimos headers con ancho dinámico
      let headers = [
        { key: "tratamientoNombre", label: "Tratamiento", sortable: false, thStyle: { width: anchoColumna } },
        { key: "precioClinica", label: "Precio Clínica", sortable: false, thStyle: { width: anchoColumna } },
        { key: "precioDescuentoPlan", label: " ", sortable: false, thStyle: { width: anchoColumna } }
      ];

      if (hayDescuentoEspecial) {
        headers.push({
          key: "precioDescuentoEspecial",
          label: "Precio con descuento especial",
          sortable: false,
          thStyle: { width: anchoColumna }
        });
      }

      // Asignamos a la propiedad reactiva
      this.headersTabla = headers;
    },


    unificarListados() {
      const mapa = new Map();

      // Primero lista base
      (this.listaTratamientos || []).forEach(t => {
        mapa.set(t.idTratamiento, { ...t });
      });

      // Luego grupo (sobre escribe si ya existe)
      (this.listaTratamientosGrupo || []).forEach(t => {
        mapa.set(t.idTratamiento, {
          ...t,
          tratamiento: t.nombreTratamiento // renombrar propiedad
        });
      });

      // Guardamos en el array filtrable
      this.listaTratamientosOriginal = Array.from(mapa.values());
      this.listaTratamientosFiltrada = [...this.listaTratamientosOriginal];
    },

    tooltipDescuento(item) {
      if (!item) return '';

      const veces = item.vecesAnio
          ? ` (${item.vecesAnio} ${item.vecesAnio === 1 ? 'vez' : 'veces'} al año)`
          : '';

      const formatos = {
        1: () => `${item.descuentoEspecial}%${veces}`,
        2: () => `${this.$options.filters.moneda(item.descuentoEspecial)} descuento${veces}`,
        3: () => `${this.$options.filters.moneda(item.descuentoEspecial)} co-pago fijo${veces}`
      };

      return formatos[item.idTipoDescuentoPlan]?.() || '';
    }
  }

}
</script>

<style scoped>
.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  height: 4vh;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
  border-radius: 20px;
  cursor: pointer;
}

.mensaje_select_tratamiento {
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
}

.g-5 {
  gap: 5px;
}

</style>